export default {
  namespaced: true,

  state: {
    token: null,
    user: null
  },

  getters: {
    token: state => state.token,
    user: state => state.user
  },

  mutations: {

  },

  actions: {
    setUserData ({ state }, { user, token }) {
      state.user = user
      state.token = token
    }
  }
}
